<svg:g xmlns:svg="http://www.w3.org/2000/svg" chart-axis [config]="axisConfig"></svg:g>

<!-- Dashed connectors carry the running level from each bar to the next (under the bars). -->
<svg:g xmlns:svg="http://www.w3.org/2000/svg" class="connectors">
    <svg:line *ngFor="let c of connectors"
              [attr.x1]="c.x1" [attr.x2]="c.x2" [attr.y1]="c.y" [attr.y2]="c.y"
              stroke="currentColor" stroke-opacity="0.35" stroke-width="1"
              stroke-dasharray="3 3"></svg:line>
</svg:g>

<svg:g xmlns:svg="http://www.w3.org/2000/svg" class="bars">
    <svg:g *ngFor="let bar of bars" class="bar-group"
           container="body" ngbPopover="{{bar.text}}" triggers="mouseenter:mouseleave"
           popoverTitle="{{bar.label}}">
        <svg:rect class="rect" rx="2"
                  [attr.x]="bar.x" [attr.y]="bar.y"
                  [attr.width]="bar.width" [attr.height]="bar.height"
                  [attr.fill]="bar.fill"></svg:rect>
    </svg:g>
</svg:g>

<!-- Semantic legend: gain / loss / total — top-right like the bar chart's series legend. -->
<svg:svg class="legend-container" xmlns:svg="http://www.w3.org/2000/svg"
         *ngIf="config.showLegend"
         x="0" y="0" height="100%">
    <svg:text text-anchor="end"
              [attr.x]="config.chartWidth - config.xPadding - xOffsets"
              y="12"
              font-size="11"
              font-weight="600"
              letter-spacing="0.02em">
        <svg:tspan class="legend" [attr.fill]="upColor"><svg:tspan>●&nbsp;</svg:tspan><svg:tspan>increase</svg:tspan></svg:tspan>
        <svg:tspan dx="14">&nbsp;</svg:tspan>
        <svg:tspan class="legend" [attr.fill]="downColor"><svg:tspan>●&nbsp;</svg:tspan><svg:tspan>decrease</svg:tspan></svg:tspan>
        <svg:tspan dx="14">&nbsp;</svg:tspan>
        <svg:tspan class="legend" [attr.fill]="totalColor"><svg:tspan>●&nbsp;</svg:tspan><svg:tspan>total</svg:tspan></svg:tspan>
    </svg:text>
</svg:svg>
